import url from 'url';
import escape from 'escape-string-regexp';
import { stripHtml } from 'string-strip-html';

export const sortAlphabetically = (prop = 'id') => {
  return function (a, b) {
    if (a[prop] > b[prop]) {
      return 1;
    } else if (a[prop] < b[prop]) {
      return -1;
    }
    return 0;
  };
};

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function toSnakeCase(str) {
  if (str === undefined || str === null) {
    return '';
  }
  return str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join('_');
}

export const truncateText = (content, limit, after) => {
  if (!content || !limit) return;
  content = content.replace(/&nbsp;/g, ' ');
  content = content.replace(/<(?:.|\n)*?>/gm, '');
  content = content.replace(/(\r\n\t|\n|\r\t)/gm, '');
  content = content.split(' ');
  content = content.slice(0, limit);
  content = content.join(' ');
  if (
    content.substr(content.length - 1) === '.' ||
    content.substr(content.length - 1) === ' '
  ) {
    content = content.substr(0, content.length - 2);
  }
  if (content.substr(content.length - 1) !== '.') {
    content = content + (after ? after : '');
  }
  return content;
};

export function stripTags(str) {
  if (str && typeof str === 'string') {
    return stripHtml(str).result;
  }
  return '';
}

export function replaceUrls(text) {
  let cleanText = '';

  if (!text) {
    return cleanText;
  }
  cleanText += text;

  const fullCmsUrl = process.env.GATSBY_CMS_URL || '';
  /* eslint-disable security/detect-non-literal-regexp */
  cleanText = cleanText.replace(new RegExp(escape(fullCmsUrl), 'g'), '');

  const cmsUrl = url.parse(fullCmsUrl).hostname;
  cleanText = cleanText.replace(new RegExp(escape(cmsUrl), 'g'), '');
  /* eslint-enable security/detect-non-literal-regexp */

  return cleanText;
}

export function localiseUrls(text) {
  // replace any url that prints the cms domain with the current deployment url
  // use to create canonical urls or similar

  let cleanText = '';
  if (!text) {
    return cleanText;
  }
  cleanText += text;

  const fullCmsUrl = process.env.GATSBY_CMS_URL || '';
  const fullFrontEndUrl = process.env.SITE_URL || '';

  /* eslint-disable security/detect-non-literal-regexp */
  cleanText = cleanText.replace(
    new RegExp(escape(fullCmsUrl), 'g'),
    fullFrontEndUrl
  );

  return cleanText;
}

/**
 * Check if browser supports storage type
 *
 * @param {string} type
 *
 **/
export function storageAvailable(type) {
  try {
    var storage = window[type],
      x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      // $FlowFixMe
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      // $FlowFixMe
      storage.length !== 0
    );
  }
}

export function recaptchaSize() {
  const isSSR = typeof window === 'undefined';
  let size = 'normal';

  if (isSSR) {
    return size;
  }

  if (window.innerWidth < 360) {
    size = 'compact';
  }

  return size;
}
